export default "__VITE_ASSET__DIjKiRJ2__"